import React, {useState} from 'react';
import {formatStrategyPrice, formatPaymentTime} from 'utils/mixins';
import {CopyIcon} from 'icons';

import './payment.scss';

const PaymentDetails = ({props}) => {
  const [idCopied, setIdCopied] = useState(false);
  const {id, status, price, time, paid, coupon} = props.location.state.payment;

  const isPaidWithCoupon = Number(coupon) > 0;

  return (
    <div className="payment-details-page">
      <div className="box payment-details">
        <div className="payment-details-field">
          <div className="payment-details-title">Status</div>
          <div className="payment-details-value">{status === 'success' ? 'Completed' : 'Failed'}</div>
        </div>
        <div className="payment-details-field">
          <div className="payment-details-title">Payment ID</div>
          <div className="payment-details-value">
            <div className="payment-id">{id}</div>
            <button
              type="button"
              onClick={async () => {
                await navigator.clipboard.writeText(id);
                setIdCopied(true);
              }}
            >
              {idCopied ? 'Copied!' : 'Copy'} <CopyIcon />
            </button>
          </div>
        </div>
        {isPaidWithCoupon ? (
          <React.Fragment>
            <div className="payment-details-field">
              <div className="payment-details-title">Price</div>
              <div className="payment-details-value">{formatStrategyPrice(price)}</div>
            </div>
            <div className="payment-details-field">
              <div className="payment-details-title">Coupon savings</div>
              <div className="payment-details-value">{formatStrategyPrice(coupon)}</div>
            </div>
            <div className="payment-details-field">
              <div className="payment-details-title">Amount paid</div>
              <div className="payment-details-value">{formatStrategyPrice(paid)}</div>
            </div>
          </React.Fragment>
        ) : (
          <div className="payment-details-field">
            <div className="payment-details-title">Price</div>
            <div className="payment-details-value">{formatStrategyPrice(price)}</div>
          </div>
        )}
        <div className="payment-details-field">
          <div className="payment-details-title">Date</div>
          <div className="payment-details-value">{formatPaymentTime(time)}</div>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;
